'use client';
import cn from 'classnames';
import type { MouseEventHandler } from 'react';

import styles from './button.module.scss';

export enum ButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  IconText = 'iconText',
  SecondaryAlert = 'secondaryAlert',
  IconTextSecondary = 'iconTextSecondary',
  IconOnlyRound = 'iconOnlyRound',
  Warning = 'warning',
}

export enum ButtonSize {
  Small = 'small',
  Regular = 'regular',
}

export default function Button({
  onClick,
  children,
  isFullSize,
  isRectangular = false,
  type = ButtonType.Primary,
  isDisabled,
  testId,
  size = ButtonSize.Regular,
  noBorder,
}: Readonly<{
  onClick: MouseEventHandler;
  children: React.ReactNode;
  isFullSize?: boolean;
  isRectangular?: boolean;
  type?: ButtonType;
  isDisabled?: boolean;
  testId?: string;
  size?: ButtonSize;
  noBorder?: boolean;
}>) {
  return (
    <div
      className={cn(styles.buttonContainer, styles[type], styles[size], {
        [styles.isFullSize]: isFullSize,
      })}
      onClick={e => {
        isDisabled ? null : onClick(e);
      }}
    >
      <button
        className={cn(styles.button, styles[type], styles[size], {
          [styles.isFullSize]: isFullSize,
          [styles.isRectangular]: isRectangular,
          [styles.noBorder]: noBorder,
        })}
        data-test-id={testId}
        disabled={isDisabled}
      >
        {children}
      </button>
    </div>
  );
}
